import { render, staticRenderFns } from "./AnalyzesEdit.vue?vue&type=template&id=63e64966&scoped=true&"
import script from "./AnalyzesEdit.vue?vue&type=script&lang=js&"
export * from "./AnalyzesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e64966",
  null
  
)

export default component.exports